// extracted by mini-css-extract-plugin
module.exports = {"bock":"button_bock__xgd5w","small":"button_small__qGKbq"};